import React from 'react'

const kohYao = {
    id: 'koh-yao',
    type: 'post',
    countryId: 'seAsia',
    title: 'Untouched Beauty in Koh Yao',
    longDate: 'December 7, 2018',
    month: 'Dec',
    date: '7',
    coverImage: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/kohyao/kohyaocover.jpg',
    content: [
        {
            text: (
                <div>To be honest, neither of us is a beach person. And yet, I'd heard from so many friends and travel blogs that the islands of Thailand were truly stunning and that we had to visit, especially since we could fly straight into the Andaman coast from Saigon for cheap. After 8 days on islands that make you think "paradise" despite the cliché, I'm still not a beach person, but I am 100% converted on Thai islands.</div>
            )
        },
        {
            text: (
                <div>We spent most of our week in Thailand on the "Koh Yaos": Koh Yao Yai and Koh Yao Noi, two of the least developed islands in the area. We started out on Koh Yao Yai, the larger and more rural of the two islands. As soon as we got there, it was clear the island didn't get many visitors. At the wooden pier (empty except for our longtail boat), we found a woman renting motorbikes, and got on one with our two backpacks. (I <i>can</i> ride a motorbike, but prefer to be on the back while Peter drives. Since he hates being a passenger, it's simply a plus that it's cheaper to get only one bike!)</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/kohyao/shells.jpg',
            detailText: 'Seashells at an abandoned beach hut.'
        },
        {
            text: (
                <div>Over the next two and a half days, we followed a vacation routine: wake up late; leisurely breakfast at our bungalow hotel; hop on the motorbike and drive to a part of the island we hadn't seen yet; stop for lunch somewhere on the side of the road; end up at a beach bar around 4 and stay through the sunset; and finally dinner at Jikgo Bar & Restaurant. The first time we left our motorbike in the sun for 20 minutes, we returned to find the leather seat boiling hot, and Peter taught me a useful lesson. Apparently, if you put a bit of water on a hot surface, the energy needed to evaporate it eats up the heat. Science!</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/kohyao/drink.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/kohyao/GypsyBar.jpg',
            detailText: 'Our favorite sunset spot, the rasta Gypsy Bar.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/kohyao/dusk.jpg',
            detailText: 'Dusk from Gypsy Bar.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/kohyao/jikgo.jpg',
            detailText: 'Jikgo Restaurant & Bar has some pretty great mojitos, in addition to delicious Thai food.'
        },
        {
            text: (
                <div>We saw few other tourists while there, especially in the north of the island where we were staying. Most people went to one of a handful of resorts on the western coast, and the island's few restaurants and bars were clustered there. This part of Thailand is predominantly Muslim, so a lot of places didn't serve alcohol; later in the trip, we even saw a sign above a trash can at a popular site asking people not to dispose of alcohol bottles because Muslims lived there. While driving, we passed rubber tree farms, seven or eight mosques, valleys of palm trees, and ornate stilt houses. It was a blissfully quiet two days.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/kohyao/crabs.jpg',
            detailText: 'It took us a day to figure out that tiny crabs make these starfish-shaped patterns on the sand.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/kohyao/palmtrees.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/kohyao/bay.jpg',
            detailText: 'Exploring a bay at the southern end of Koh Yao Yai.'
        },
        {
            text: (
                <div>The longtail boat trip took just ten minutes to get to Koh Yao Noi, the north island. Koh Yao Noi is smaller and more developed, so there are rarely five minute stretches on the main road without snack shops, hotels, or signs in English selling something. However, it was charming and and still more rural than developed. Like on Koh Yao Yai, as soon as you get off the main road you're likely to be going along a rocky dirt path. The one day I tried driving, our road suddenly became a boulder field. I stopped and made Peter switch to navigate us out. A concerned woman driving smoothly along the path pulled over to try to help, and 30 seconds later a motorbike towing a cart of people roared past. I don't know how they do it!</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/kohyao/PeterBike.jpg',
            detailText: 'The dirt road of death! It was scarier in person, I swear.'
        },
        {
            text: (
                <div>Koh Yao Noi offers more to do and a lot more places to get food and drink. We ate at a few great spots while there, though the most memorable experience was Rice Paddy Viewpoint, where we were caught in a thunderstorm at the top of a hill and stayed for four hours until we could brave the roads. The restaurant has gorgeous 180 degree views of the ocean and islands beyond, and we watched the sunset fade as the ominous rain clouds approached from one side and darkened the entire sky. I loved it.</div>
            )
        },
        {
            text: (
                <div>In addition to their rural beauty, the best facet of the Koh Yaos is the friendliness and openness of the locals. Everyone we interacted with was lovely, and people went out of their way to accomodate us – like when we cut the timing too close with our last lunch and needed to catch the ferry, and the restaurant owner grabbed her bike and drove Peter there to make sure he'd catch it.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/kohyao/ricepaddy.jpg',
            detailText: 'Sunset from Rice Paddy Restaurant.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/kohyao/thunderstorm.jpg',
            detailText: 'The sky turned into crazy shades of fire as the thunderstorm rolled in.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/kohyao/thakowwaterfall.jpg',
            detailText: 'Thakow Waterfall on Koh Yao Noi.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/kohyao/lunchviews.jpg',
            detailText: 'Pretty great lunch views.'
        },
        {
            text: (
                <div>One day, we took a boat tour from Koh Yao Noi around the nearby island archipelago. Though they're uninhabited, these pristine little beaches are visited by dozens or possibly hundreds of boats a day, depositing tourists for an hour of wandering or beach-lying before jetting off to the next spot. Our boat operator didn't speak any English, so I have no idea what any of the spots were called. Even though it was super touristy, it was still cool to see this tiny islands – and even cooler to find the huge lizards roaming them! We got a picture of a small one, but they can apparently get up to 3 or 4 feet long.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/kohyao/boattour.jpg',
            detailText: 'One of the tiny, crowded islands on our boat tour.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/kohyao/overheadview.jpg',
            detailText: 'We hiked to the top of this limestone peak island and were rewarded with views of turquoise water.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/kohyao/usviewpoint.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/kohyao/lizard.jpg',
            detailText: 'Beware friendly lizards! (I was actually scared though.)'
        },
        {
            text: (
                <div>I'm already plotting my way back. There are a few Muay Thai spots, and we found a training camp on Koh Yao Noi with beautiful facilities where you can stay, eat your meals, and take twice-daily classes for an incredibly reasonable price. There are also a few places on both islands offering yoga. Peter is somewhat less keen for 2 weeks chilling on an island, but I don't think I could get bored between $9 massages, $7 yoga, good wifi at cute coffee shops, and endless books on Kindle.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/kohyao/hideout.jpg',
            detailText: 'We searched for The Hideout, but never found it.'
        },
        {
            text: (
                <div>Later in the week as we ferried back to Phuket, we stopped for a couple of hours at Koh Phi Phi. It's home to Maya Bay, made famous by Leo DiCaprio's film <i>The Beach</i>, and is such a popular destination that 4,000 people visit the small bay every day. It's suffered so much as a result that the government <a href="https://www.thesun.co.uk/travel/5566800/thailand-maya-bay-the-beach-closed-tourists/">finally closed Maya Bay to allow the ecosystem to recover</a>. When Peter's parents visited 30 years ago, they said it was pristine and wild; <a href="https://travelingcanucks.com/2012/10/koh-phi-phi-25-years-later/">here's a photo</a> comparing that with the paved-over Disneyland it is today. The photo doesn't even show how bad it is in person – masses of people leaving burger joints to get alcohol "buckets," and 20-year-old travelers standing outside clubs on every block promoting that night's lineup. There is nothing of Thailand there.</div>
            )
        },
        {
            text: (
                <div>Our brief stop made me so glad again that we'd had the chance to visit Koh Yao instead. Of course I do feel conflicted about searching for the places that "other people don't go to" and "you need to visit before it's ruined!"; doesn't that eventually introduce more tourism and therefore destruction? I imagine that travel bloggers with large platforms feel even more conflicted, since their recommendation to see an "unseen" place can have a big effect on the number of people that go. I'm not sure what the answer is, but the Thai government's step to limit visitors to areas under stress from overtourism is a good first step.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/kohyao/kohphiphi1.jpg',
            detailText: 'When you get to the top, make sure to take a photo with the giant ‘Viewpoint 1’ sign so no one will be confused which viewpoint you were at!'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/kohyao/kohphiphi2.jpg'
        },
    ]
}

export default kohYao


// WEBPACK FOOTER //
// ./src/Posts/Content/KohYao.js